/**
 * Factory function for initial editor modal state.
 * Fresh object each call - used on mount and when switching maps
 * (avoids modalState.mapping leaking across mapId).
 */

import type { EditorModalState } from '../types'

export function createInitialEditorModalState(): EditorModalState {
  return {
    save: false,
    noTypes: false,
    mapping: false,
    error: { show: false, message: '' },
    autoLink: false,
    export: false,
    excelImport: { show: false }
  }
}
